import './index.scss';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import { get } from '../../../util/request';
import { userInfo } from '../../../redux/slice';
import { useSelector } from 'react-redux';
import { Form, Popover } from 'antd';
import { getLocalizedContent, isUSDirectDepositOnly } from '../taxQuestionnaireRules';
import useTaxContent from '../useTaxContent';

export default RefundDetails; function RefundDetails({ TaxFilingQuestionnaire, Country, HandleTaxFilingQuestionnaireSave }) {
    const { t } = useTranslation();
    const user = useSelector(userInfo);
    const [taxRefund, setTaxRefund] = useState({ method: '', address: '' });
    const [taxRefundAddress, setTaxRefundAddress] = useState({ mailingAddress: '', address2: '', province: '', country: '', postal: '', disable: false });
    const FormItem = Form.Item;
    const formRef = Form.useFormInstance();
    const viewOnly = TaxFilingQuestionnaire?.Status?.toLowerCase() !== '' && TaxFilingQuestionnaire?.Status?.toLowerCase() !== 'new';
    const [regionalOffice, setRegionalOffice] = useState([]);
    const provinceRegex = /^[a-zA-Z0-9\s-]*$/;
    const line1Regex = /^[\x20-\x7E]+$/;
    const line2Regex = /^[a-zA-Z0-9\s-]*$/;
    const previewDetail = JSON.parse(sessionStorage.getItem('previewDetail'));
    const isDirectDeposit = isUSDirectDepositOnly(TaxFilingQuestionnaire);
    // Configurable via the "Wise Reminder" content row; falls back to the i18n placeholder.
    const wiseReminder = getLocalizedContent(useTaxContent('Wise Reminder'), window.localStorage.lang);
    const formatNumber = (value) => {
        if (value) {
            return Number(value).toLocaleString()
        } else {
            return 0
        }
    }

    const handleChange = async (key, value) => {
        setTaxRefund(prevData => ({
            ...prevData,
            [key]: value
        }));
    }

    const handleChangeAddress = async (key, value) => {
        setTaxRefundAddress(prevData => ({
            ...prevData,
            [key]: value
        }));
    }

    const updateAddress = async (regionalOffice) => {
        if (regionalOffice === 'Same as Mailing Address') {
            const validLine1 = line1Regex.test(TaxFilingQuestionnaire.TaxMailingAddressStreet);
            const validLine2 = line2Regex.test(TaxFilingQuestionnaire.TaxMailingAddressCity);
            const validProvince = provinceRegex.test(TaxFilingQuestionnaire.TaxMailingAddressState);

            if (validLine1 && validLine2 && validProvince) {
                formRef?.setFieldValue('CheckMailingAddressStreet', TaxFilingQuestionnaire.TaxMailingAddressStreet);
                formRef?.setFieldValue('CheckMailingAddressCity', TaxFilingQuestionnaire.TaxMailingAddressCity);
                formRef?.setFieldValue('CheckMailingAddressState', TaxFilingQuestionnaire.TaxMailingAddressState);
                setTaxRefundAddress(prevData => ({
                    ...prevData,
                    disable: true
                }));
            }
            else {
                formRef?.setFieldValue('CheckMailingAddressOption', 'Other Address');
                formRef?.setFieldValue('CheckMailingAddressStreet', validLine1 ? TaxFilingQuestionnaire.TaxMailingAddressStreet : '');
                formRef?.setFieldValue('CheckMailingAddressCity', validLine2 ? TaxFilingQuestionnaire.TaxMailingAddressCity : '');
                formRef?.setFieldValue('CheckMailingAddressState', validProvince ? TaxFilingQuestionnaire.TaxMailingAddressState : '');
                setTaxRefundAddress(prevData => ({
                    ...prevData,
                    disable: false
                }));
            }

            formRef?.setFieldValue('CheckMailingAddressCountry', TaxFilingQuestionnaire.TaxMailingCountry);
            formRef?.setFieldValue('CheckMailingAddressZipCode', TaxFilingQuestionnaire?.TaxMailingAddressZipcode);
        }
        else if (regionalOffice === 'Other Address' || regionalOffice === '') {
            setTaxRefundAddress(prevData => ({
                ...prevData,
                disable: regionalOffice === '' ? true : false
            }));
            formRef?.setFieldValue('CheckMailingAddressStreet', '');
            formRef?.setFieldValue('CheckMailingAddressCity', '');
            formRef?.setFieldValue('CheckMailingAddressState', '');
            formRef?.setFieldValue('CheckMailingAddressCountry', '');
            formRef?.setFieldValue('CheckMailingAddressZipCode', '');
        }
        else {
            let params = {
                accessToken: user.accessToken,
                userId: user.userId,
                type: regionalOffice
            };
            const data = await get('/taxQuestionnaire/waltonOffice', params);
            if (data) {
                setTaxRefundAddress(prevData => ({
                    ...prevData,
                    disable: true
                }));
                formRef?.setFieldValue('CheckMailingAddressStreet', data.addressStreet);
                formRef?.setFieldValue('CheckMailingAddressCity', data.addressCity);
                formRef?.setFieldValue('CheckMailingAddressState', data.addressState);
                formRef?.setFieldValue('CheckMailingAddressCountry', data.addressCountry);
                formRef?.setFieldValue('CheckMailingAddressZipCode', data.addressZipCode);
            }
        }
    }

    const regionalOfficeList = async () => {
        let params = {
            accessToken: user.accessToken,
            userId: user.userId
        };
        const data = await get('/taxQuestionnaire/waltonOffice/list', params);

        if (data) {
            setRegionalOffice(data);
        }
    }

    useEffect(() => {
        regionalOfficeList();
        setTaxRefund(prevData => ({
            ...prevData,
            method: isDirectDeposit ? 'Bank transfer US' : TaxFilingQuestionnaire.TaxRefundPaymentMethod
        }));

        //direct deposit
        if(isDirectDeposit) {
            formRef?.setFieldValue('TaxRefundPaymentMethod', 'Bank transfer US');
            HandleTaxFilingQuestionnaireSave('TaxRefundPaymentMethod', 'Bank transfer US');
        }

        const validLine1 = line1Regex.test(TaxFilingQuestionnaire.TaxMailingAddressStreet);
        const validLine2 = line2Regex.test(TaxFilingQuestionnaire.TaxMailingAddressCity);
        const validProvince = provinceRegex.test(TaxFilingQuestionnaire.TaxMailingAddressState);
        if (TaxFilingQuestionnaire?.CheckMailingAddressOption === 'Same as Mailing Address') {
            if (!(validLine1 && validLine2 && validProvince)) {
                formRef?.setFieldValue('CheckMailingAddressOption', 'Other Address');
                setTaxRefundAddress(prevData => ({
                    ...prevData,
                    disable: false
                }));
            }
            else {
                setTaxRefundAddress(prevData => ({
                    ...prevData,
                    disable: true
                }));
            }

            formRef?.setFieldValue('CheckMailingAddressStreet', validLine1 ? TaxFilingQuestionnaire.TaxMailingAddressStreet : '');
            formRef?.setFieldValue('CheckMailingAddressCity', validLine2 ? TaxFilingQuestionnaire.TaxMailingAddressCity : '');
            formRef?.setFieldValue('CheckMailingAddressState', validProvince ? TaxFilingQuestionnaire.TaxMailingAddressState : '');
            formRef?.setFieldValue('CheckMailingAddressCountry', TaxFilingQuestionnaire.TaxMailingCountry);
            formRef?.setFieldValue('CheckMailingAddressZipCode', TaxFilingQuestionnaire?.TaxMailingAddressZipcode);
        } else if (TaxFilingQuestionnaire?.CheckMailingAddressOption === 'Other Address' || TaxFilingQuestionnaire?.CheckMailingAddressOption === '') {
            setTaxRefundAddress(prevData => ({
                ...prevData,
                disable: regionalOffice === '' ? true : false
            }));
        }
        else {
            setTaxRefundAddress(prevData => ({
                ...prevData,
                disable: true
            }));
        }
    }, []);


    return (
        <>
            <div id='stepper-methods-tax-refund-div'>
                <div className='row tax-filing-questionnaire-title'>
                    <p>
                        {t('REFUND DETAILS')}
                    </p>
                </div>
                <div className='row stepper-methods-tax-refund-content'>
                    <div className='col-md-12 row input-row'>
                        <div className='col-md-9 tax-filing-questionnaire-notes'>
                            <svg
                                className="svg-circle"
                                xmlns="http://www.w3.org/2000/svg"
                                width="20"
                                height="20"
                                viewBox="0 0 20 20"
                                fill="none"
                            >
                                <path
                                    d="M10 20C4.48674 20 0 15.5054 0 9.97817C0 4.45098 4.48674 0 10 0C15.5133 0 20 4.47756 20 9.97817C20 15.4788 15.5133 20 10 20ZM10 1.84493C5.50189 1.84493 1.84091 5.49302 1.84091 9.97817C1.84091 14.4633 5.50189 18.1551 10 18.1551C14.4981 18.1551 18.1591 14.488 18.1591 9.97817C18.1591 5.46835 14.5 1.84493 10 1.84493Z"
                                    fill="#003448"
                                />
                            </svg>
                            <svg
                                className="svg-exclamation"
                                xmlns="http://www.w3.org/2000/svg"
                                width="2"
                                height="10"
                                viewBox="0 0 2 10"
                                fill="none"
                            >
                                <path
                                    d="M0.918557 9.50633C0.412028 9.50633 0 9.09255 0 8.58387V4.72129C0 4.21261 0.412028 3.79883 0.918557 3.79883C1.42509 3.79883 1.83711 4.21261 1.83711 4.72129V8.58387C1.83711 9.09255 1.42509 9.50633 0.918557 9.50633Z"
                                    fill="#003448"
                                />
                                <path
                                    d="M0.918557 2.89808C0.412028 2.89808 0 2.4843 0 1.97561V1.41758C0 0.908897 0.412028 0.495117 0.918557 0.495117C1.42509 0.495117 1.83711 0.908897 1.83711 1.41758V1.97561C1.83711 2.4843 1.42509 2.89808 0.918557 2.89808Z"
                                    fill="#003448"
                                />
                            </svg>
                            <span>{t('Please enter your response using English characters and numbers only, except where special instructions are indicated.')}</span>
                        </div>
                    </div>
                    <div className='col-md-12 row input-row'>
                        <div className='col-md-9 methods-details'>
                            <div className='detail-title col-md-8'>{t('Projects Exited').replaceAll('{taxYear}', TaxFilingQuestionnaire?.TaxFilingYear)}</div>
                            <div className='details col-md-4'>
                                {TaxFilingQuestionnaire.ProjectDisposedCurrentYear}
                            </div>
                        </div>
                    </div>
                    <div className='col-md-12 row input-row'>
                        <div className='col-md-9 methods-details'>
                            <div className='detail-title col-md-8'>{t('Total Withholding Amount')}</div>
                            <div className='details col-md-4'>
                                {t('USD')} {formatNumber(TaxFilingQuestionnaire?.TotalWithholdingAmount)} {t('USD1')}
                            </div>
                        </div>
                    </div>
                    <div className='col-md-12 row input-row'>
                        <div className='col-md-9 methods-details'>
                            <div className='detail-title col-md-8'>{t('Ways to receive US Tax Refund')}</div>
                            <div className='details col-md-4'>
                                <FormItem
                                    name="TaxRefundPaymentMethod"
                                    rules={[{ required: true, message: t('This field is required') }]}
                                >
                                    <select disabled={isDirectDeposit ? isDirectDeposit : viewOnly} onChange={(e) => { handleChange('method', e.target.value); HandleTaxFilingQuestionnaireSave('TaxRefundPaymentMethod', e.target.value); }}>
                                        <option value=''>{t('Select Method')}</option>
                                        <option value='Bank transfer US'>{t('Direct deposit to a bank account in U.S.')}</option>
                                        {
                                            !isDirectDeposit && (<option value='US Tax Refund Cheque'>{t('U.S. Tax Refund Cheque')}</option>)
                                        }
                                    </select>
                                </FormItem>
                            </div>
                        </div>
                    </div>

                    <div className='col-md-12 row input-row'>
                        <div className='col-md-12 refund-check-icons-3'>
                            <svg
                                className="svg-circle"
                                xmlns="http://www.w3.org/2000/svg"
                                width="20"
                                height="20"
                                viewBox="0 0 20 20"
                                fill="none"
                            >
                                <path
                                    d="M10 20C4.48674 20 0 15.5054 0 9.97817C0 4.45098 4.48674 0 10 0C15.5133 0 20 4.47756 20 9.97817C20 15.4788 15.5133 20 10 20ZM10 1.84493C5.50189 1.84493 1.84091 5.49302 1.84091 9.97817C1.84091 14.4633 5.50189 18.1551 10 18.1551C14.4981 18.1551 18.1591 14.488 18.1591 9.97817C18.1591 5.46835 14.5 1.84493 10 1.84493Z"
                                    fill="#dd0606"
                                />
                            </svg>
                            <svg
                                className="svg-exclamation"
                                xmlns="http://www.w3.org/2000/svg"
                                width="2"
                                height="10"
                                viewBox="0 0 2 10"
                                fill="none"
                            >
                                <path
                                    d="M0.918557 9.50633C0.412028 9.50633 0 9.09255 0 8.58387V4.72129C0 4.21261 0.412028 3.79883 0.918557 3.79883C1.42509 3.79883 1.83711 4.21261 1.83711 4.72129V8.58387C1.83711 9.09255 1.42509 9.50633 0.918557 9.50633Z"
                                    fill="#dd0606"
                                />
                                <path
                                    d="M0.918557 2.89808C0.412028 2.89808 0 2.4843 0 1.97561V1.41758C0 0.908897 0.412028 0.495117 0.918557 0.495117C1.42509 0.495117 1.83711 0.908897 1.83711 1.41758V1.97561C1.83711 2.4843 1.42509 2.89808 0.918557 2.89808Z"
                                    fill="#dd0606"
                                />
                            </svg>
                        </div>
                        <div className='refund-check-notes'>
                            <span>
                                <p>{t('IRS_Notes')}</p>
                                <br />
                                <p>{t('IRS_Notes2')}</p>
                                <br />
                                <p>{t('IRS_Notes3')}</p>
                            </span>
                        </div>
                    </div>

                    {
                        formRef?.getFieldValue('TaxRefundPaymentMethod') === 'Bank transfer US' && (<>
                            <div className='col-md-12 row input-row'>
                                <div className='col-md-9 tax-filing-questionnaire-notes'>
                                    <svg
                                        className="svg-circle"
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="20"
                                        height="20"
                                        viewBox="0 0 20 20"
                                        fill="none"
                                    >
                                        <path
                                            d="M10 20C4.48674 20 0 15.5054 0 9.97817C0 4.45098 4.48674 0 10 0C15.5133 0 20 4.47756 20 9.97817C20 15.4788 15.5133 20 10 20ZM10 1.84493C5.50189 1.84493 1.84091 5.49302 1.84091 9.97817C1.84091 14.4633 5.50189 18.1551 10 18.1551C14.4981 18.1551 18.1591 14.488 18.1591 9.97817C18.1591 5.46835 14.5 1.84493 10 1.84493Z"
                                            fill="#003448"
                                        />
                                    </svg>
                                    <svg
                                        className="svg-exclamation"
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="2"
                                        height="10"
                                        viewBox="0 0 2 10"
                                        fill="none"
                                    >
                                        <path
                                            d="M0.918557 9.50633C0.412028 9.50633 0 9.09255 0 8.58387V4.72129C0 4.21261 0.412028 3.79883 0.918557 3.79883C1.42509 3.79883 1.83711 4.21261 1.83711 4.72129V8.58387C1.83711 9.09255 1.42509 9.50633 0.918557 9.50633Z"
                                            fill="#003448"
                                        />
                                        <path
                                            d="M0.918557 2.89808C0.412028 2.89808 0 2.4843 0 1.97561V1.41758C0 0.908897 0.412028 0.495117 0.918557 0.495117C1.42509 0.495117 1.83711 0.908897 1.83711 1.41758V1.97561C1.83711 2.4843 1.42509 2.89808 0.918557 2.89808Z"
                                            fill="#003448"
                                        />
                                    </svg>
                                    {
                                        wiseReminder ? <span dangerouslySetInnerHTML={{ __html: wiseReminder }} />
                                            : <span>{t('Wise_Reminder_Placeholder')}</span>
                                    }
                                </div>
                            </div>
                            <div className='col-md-12 row input-row'>
                                <div className='col-md-9 methods-details'>
                                    <div className='col-md-8'>
                                        <span>{t('Routing number **')}</span>
                                        <div className='col-md-12 refund-check-icons-4'>
                                            <svg
                                                className="svg-circle"
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="20"
                                                height="20"
                                                viewBox="0 0 20 20"
                                                fill="none"
                                            >
                                                <path
                                                    d="M10 20C4.48674 20 0 15.5054 0 9.97817C0 4.45098 4.48674 0 10 0C15.5133 0 20 4.47756 20 9.97817C20 15.4788 15.5133 20 10 20ZM10 1.84493C5.50189 1.84493 1.84091 5.49302 1.84091 9.97817C1.84091 14.4633 5.50189 18.1551 10 18.1551C14.4981 18.1551 18.1591 14.488 18.1591 9.97817C18.1591 5.46835 14.5 1.84493 10 1.84493Z"
                                                    fill="#003448"
                                                />
                                            </svg>
                                            <svg
                                                className="svg-exclamation"
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="2"
                                                height="10"
                                                viewBox="0 0 2 10"
                                                fill="none"
                                            >
                                                <path
                                                    d="M0.918557 9.50633C0.412028 9.50633 0 9.09255 0 8.58387V4.72129C0 4.21261 0.412028 3.79883 0.918557 3.79883C1.42509 3.79883 1.83711 4.21261 1.83711 4.72129V8.58387C1.83711 9.09255 1.42509 9.50633 0.918557 9.50633Z"
                                                    fill="#003448"
                                                />
                                                <path
                                                    d="M0.918557 2.89808C0.412028 2.89808 0 2.4843 0 1.97561V1.41758C0 0.908897 0.412028 0.495117 0.918557 0.495117C1.42509 0.495117 1.83711 0.908897 1.83711 1.41758V1.97561C1.83711 2.4843 1.42509 2.89808 0.918557 2.89808Z"
                                                    fill="#003448"
                                                />
                                            </svg>
                                        </div>
                                        <p className='routing-number-notes'>{t('Please enter your 9-digit U.S. bank routing number.')}</p>
                                    </div>
                                    <div className='col-md-4'>
                                        <FormItem
                                            name="USBankAccountRoutingNumber"
                                            rules={[{ required: true, message: t('This field is required') }, { pattern: /^[0-9]{9}$/, message: t('Please enter your 9-digit U.S. bank routing number.') }]}
                                        >
                                            <input disabled={viewOnly} type='text' maxLength={9} onKeyDown={(e) => {
                                                if (!/[0-9]/.test(e.key) && e.key !== "Backspace") {
                                                    e.preventDefault();
                                                }
                                            }} />
                                        </FormItem>
                                    </div>
                                </div>
                            </div>
                            <div className='col-md-12 row input-row'>
                                <div className='col-md-9 methods-details'>
                                    <div className='col-md-8'>
                                        <span>{t('Type')}</span>
                                    </div>
                                    <div className='col-md-4'>
                                        <FormItem
                                            name="USBankAccountType"
                                            rules={[{ required: true, message: t('This field is required') }]}
                                        >
                                            <select disabled={viewOnly}>
                                                <option value=''>{t('Select Account Type')}</option>
                                                <option value='Checking'>{t('Checking')}</option>
                                                <option value='Savings'>{t('Savings')}</option>
                                            </select>
                                        </FormItem>

                                    </div>
                                </div>
                            </div>
                            <div className='col-md-12 row input-row'>
                                <div className='col-md-9 methods-details'>
                                    <div className='col-md-8'>
                                        <span>{t('Account number')}</span>
                                    </div>
                                    <div className='col-md-4'>
                                        <FormItem
                                            name="USBankAccountNumber"
                                            rules={[{ required: true, message: t('This field is required') }, { pattern: /^[0-9]+$/, message: t('Invalid input.') }]}
                                        >
                                            <input disabled={viewOnly} type='text' onKeyDown={(e) => {
                                                if (!/[0-9]/.test(e.key) && e.key !== "Backspace") {
                                                    e.preventDefault();
                                                }
                                            }} />
                                        </FormItem>
                                    </div>
                                </div>
                            </div>
                        </>)
                    }

                    {
                        formRef?.getFieldValue('TaxRefundPaymentMethod') === 'US Tax Refund Cheque' && (<>
                            <div className='col-md-12 row input-row'>
                                <div className='col-md-9 methods-details'>
                                    <div className='col-md-8'>
                                        <span>{t('Tax Refund Address')}</span>
                                    </div>
                                    <div className='col-md-4'>
                                        <FormItem
                                            name="CheckMailingAddressOption"
                                            rules={[{ required: true, message: t('This field is required') }]}
                                        >
                                            <select disabled={viewOnly} onChange={(e) => { handleChange('address', e.target.value); updateAddress(e.target.value); }}>
                                                <option value=''></option>
                                                {
                                                    (regionalOffice != null && (user?.location === 'Hong Kong' || previewDetail?.salesOffice === 'Hong Kong')) && (<>
                                                        {
                                                            regionalOffice?.map((item) => (<>
                                                                <option value={item.region}>{t(item.region)}</option>
                                                            </>))
                                                        }
                                                    </>)
                                                }
                                                <option value='Same as Mailing Address'>{t('Same as Mailing Address')}</option>
                                                <option value='Other Address'>{t('Other Address')}</option>
                                            </select>
                                        </FormItem>
                                    </div>
                                </div>
                            </div>

                            <div className='col-md-12 row input-row'>
                                <div className='col-md-9 refund-check-icons-2'>
                                    <svg
                                        className="svg-circle"
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="20"
                                        height="20"
                                        viewBox="0 0 20 20"
                                        fill="none"
                                    >
                                        <path
                                            d="M10 20C4.48674 20 0 15.5054 0 9.97817C0 4.45098 4.48674 0 10 0C15.5133 0 20 4.47756 20 9.97817C20 15.4788 15.5133 20 10 20ZM10 1.84493C5.50189 1.84493 1.84091 5.49302 1.84091 9.97817C1.84091 14.4633 5.50189 18.1551 10 18.1551C14.4981 18.1551 18.1591 14.488 18.1591 9.97817C18.1591 5.46835 14.5 1.84493 10 1.84493Z"
                                            fill="#003448"
                                        />
                                    </svg>
                                    <svg
                                        className="svg-exclamation"
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="2"
                                        height="10"
                                        viewBox="0 0 2 10"
                                        fill="none"
                                    >
                                        <path
                                            d="M0.918557 9.50633C0.412028 9.50633 0 9.09255 0 8.58387V4.72129C0 4.21261 0.412028 3.79883 0.918557 3.79883C1.42509 3.79883 1.83711 4.21261 1.83711 4.72129V8.58387C1.83711 9.09255 1.42509 9.50633 0.918557 9.50633Z"
                                            fill="#003448"
                                        />
                                        <path
                                            d="M0.918557 2.89808C0.412028 2.89808 0 2.4843 0 1.97561V1.41758C0 0.908897 0.412028 0.495117 0.918557 0.495117C1.42509 0.495117 1.83711 0.908897 1.83711 1.41758V1.97561C1.83711 2.4843 1.42509 2.89808 0.918557 2.89808Z"
                                            fill="#003448"
                                        />
                                    </svg>
                                    <span>{t('Please provide your name and the cheque mailing address in English only, as the cheque will be issued by the U.S. Internal Revenue Service (IRS)')}</span>
                                </div>
                            </div>

                            <div className='col-md-12 row input-row'>
                                <div className='col-md-9 methods-details'>
                                    <div className='col-md-8'>
                                        <span>{t('Please provide your full name that should appear on the refund check issued by the U.S. Treasury Department')} <i className='required'>*</i></span>
                                    </div>
                                    <div className='col-md-4'>
                                        <FormItem
                                            name="FullNameOnCheque"
                                            rules={[{ required: true, message: t('This field is required') },
                                            { pattern: TaxFilingQuestionnaire?.Status?.toLowerCase() === 'new' ? /^[A-Za-z]+(?:[ '-][A-Za-z]+)*(?:,\s*[A-Za-z]+(?:[ '-][A-Za-z]+)*)?$/ : /^.*$/, message: t('Invalid input.') }
                                            ]}
                                        >
                                            <input disabled={viewOnly} type='text' />
                                        </FormItem>
                                    </div>
                                </div>
                            </div>
                            <div className='col-md-12 row input-row'>
                                <div className='col-md-9 methods-details'>
                                    <div className='col-md-8'>
                                        <span>{t('Cheque Mailing Address Line 1 (Street, House No./Apt No., Building)')}<i className='required'>*</i></span>
                                        <Popover
                                            title={t('Cheque Mailing Address Line 1 (Street, House No./Apt No., Building)')}
                                            content={
                                                <div>
                                                    <p>{t('Address_Line_1_Tooltip')}</p>
                                                </div>
                                            }

                                            className='pop-over-container'

                                        >
                                            <svg
                                                className="svg-circle"
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="20"
                                                height="20"
                                                viewBox="0 0 20 20"
                                                fill="none"
                                            >
                                                <path
                                                    d="M10 20C4.48674 20 0 15.5054 0 9.97817C0 4.45098 4.48674 0 10 0C15.5133 0 20 4.47756 20 9.97817C20 15.4788 15.5133 20 10 20ZM10 1.84493C5.50189 1.84493 1.84091 5.49302 1.84091 9.97817C1.84091 14.4633 5.50189 18.1551 10 18.1551C14.4981 18.1551 18.1591 14.488 18.1591 9.97817C18.1591 5.46835 14.5 1.84493 10 1.84493Z"
                                                    fill="#003448"
                                                />
                                            </svg>
                                            <svg
                                                className="svg-exclamation"
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="2"
                                                height="10"
                                                viewBox="0 0 2 10"
                                                fill="none"
                                            >
                                                <path
                                                    d="M0.918557 9.50633C0.412028 9.50633 0 9.09255 0 8.58387V4.72129C0 4.21261 0.412028 3.79883 0.918557 3.79883C1.42509 3.79883 1.83711 4.21261 1.83711 4.72129V8.58387C1.83711 9.09255 1.42509 9.50633 0.918557 9.50633Z"
                                                    fill="#003448"
                                                />
                                                <path
                                                    d="M0.918557 2.89808C0.412028 2.89808 0 2.4843 0 1.97561V1.41758C0 0.908897 0.412028 0.495117 0.918557 0.495117C1.42509 0.495117 1.83711 0.908897 1.83711 1.41758V1.97561C1.83711 2.4843 1.42509 2.89808 0.918557 2.89808Z"
                                                    fill="#003448"
                                                />
                                            </svg>
                                        </Popover>
                                    </div>
                                    <div className='col-md-4'>
                                        <FormItem
                                            name="CheckMailingAddressStreet"
                                            rules={[{ required: true, message: t('This field is required') }, { pattern: TaxFilingQuestionnaire?.Status?.toLowerCase() === 'new' ? line1Regex : undefined, message: t('Invalid input.') }]}
                                        >
                                            <textarea disabled={viewOnly ? true : taxRefundAddress.disable} onChange={(e) => handleChangeAddress('address', e.target.value)}></textarea>
                                        </FormItem>
                                    </div>
                                </div>
                                <div className='col-md-9 methods-details'>
                                    <div className='col-md-8'>
                                        <span>{t('Cheque Mailing Address Line 2 (City, District, Town, Post Office)')}<i className='required'>*</i></span>
                                        <Popover
                                            title={t('Cheque Mailing Address Line 2 (City, District, Town, Post Office)')}
                                            content={
                                                <div>
                                                    <p>{t('Address_Line_2_Tooltip')}</p>
                                                </div>
                                            }

                                            className='pop-over-container'

                                        >
                                            <svg
                                                className="svg-circle"
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="20"
                                                height="20"
                                                viewBox="0 0 20 20"
                                                fill="none"
                                            >
                                                <path
                                                    d="M10 20C4.48674 20 0 15.5054 0 9.97817C0 4.45098 4.48674 0 10 0C15.5133 0 20 4.47756 20 9.97817C20 15.4788 15.5133 20 10 20ZM10 1.84493C5.50189 1.84493 1.84091 5.49302 1.84091 9.97817C1.84091 14.4633 5.50189 18.1551 10 18.1551C14.4981 18.1551 18.1591 14.488 18.1591 9.97817C18.1591 5.46835 14.5 1.84493 10 1.84493Z"
                                                    fill="#003448"
                                                />
                                            </svg>
                                            <svg
                                                className="svg-exclamation"
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="2"
                                                height="10"
                                                viewBox="0 0 2 10"
                                                fill="none"
                                            >
                                                <path
                                                    d="M0.918557 9.50633C0.412028 9.50633 0 9.09255 0 8.58387V4.72129C0 4.21261 0.412028 3.79883 0.918557 3.79883C1.42509 3.79883 1.83711 4.21261 1.83711 4.72129V8.58387C1.83711 9.09255 1.42509 9.50633 0.918557 9.50633Z"
                                                    fill="#003448"
                                                />
                                                <path
                                                    d="M0.918557 2.89808C0.412028 2.89808 0 2.4843 0 1.97561V1.41758C0 0.908897 0.412028 0.495117 0.918557 0.495117C1.42509 0.495117 1.83711 0.908897 1.83711 1.41758V1.97561C1.83711 2.4843 1.42509 2.89808 0.918557 2.89808Z"
                                                    fill="#003448"
                                                />
                                            </svg>
                                        </Popover>
                                    </div>
                                    <div className='col-md-4'>
                                        <FormItem
                                            name="CheckMailingAddressCity"
                                            rules={[{ required: true, message: t('This field is required') }, { pattern: TaxFilingQuestionnaire?.Status?.toLowerCase() === 'new' ? /^[A-Za-z0-9 ]+$/ : undefined, message: t('Invalid input.') }]}
                                        >
                                            <textarea disabled={viewOnly ? true : taxRefundAddress.disable} onChange={(e) => handleChangeAddress('address', e.target.value)}></textarea>
                                        </FormItem>
                                    </div>
                                </div>
                                <div className='col-md-9 methods-details'>
                                    <div className='col-md-8'>
                                        <span>{t('Province, State, and County')}</span>
                                    </div>
                                    <div className='col-md-4'>
                                        <FormItem
                                            name="CheckMailingAddressState"
                                            rules={[{ required: false, message: t('This field is required') }, { pattern: /^[a-zA-Z0-9\s-]*$/, message: t('Invalid input.') }]}
                                        >
                                            <input type='text' disabled={viewOnly ? true : taxRefundAddress.disable} />
                                        </FormItem>
                                    </div>
                                </div>

                                <div className='col-md-9 methods-details'>
                                    <div className='col-md-8'>
                                        <span>{t('Country')}<i className='required'>*</i></span>
                                    </div>
                                    <div className='col-md-4'>
                                        <FormItem
                                            name="CheckMailingAddressCountry"
                                            rules={[{ required: true, message: t('This field is required') }]}
                                        >
                                            <select disabled={viewOnly ? true : taxRefundAddress.disable}>
                                                <option value=''>{t('Select Country')}</option>
                                                {
                                                    Country != null && (<>
                                                        {
                                                            Country?.map((item) => (<>
                                                                <option value={item.name}>{item.name}</option>
                                                            </>))
                                                        }
                                                    </>)
                                                }
                                            </select>
                                        </FormItem>
                                    </div>
                                </div>

                                <div className='col-md-9 methods-details'>
                                    <div className='col-md-8'>
                                        <span>{t('ZIP/Postal Code')}</span>
                                    </div>
                                    <div className='col-md-4'>
                                        <FormItem
                                            name="CheckMailingAddressZipCode"
                                            rules={[{ required: false, message: t('This field is required') },
                                            {
                                                pattern: /^[a-zA-Z0-9\s-]{0,10}$/, message: t('Invalid Postal Code')
                                            }]}
                                        >
                                            <input type='text' disabled={viewOnly ? true : taxRefundAddress.disable} />
                                        </FormItem>
                                    </div>
                                </div>
                            </div>
                        </>)
                    }
                </div>
            </div>
        </>
    );
}